"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyTypeWidget = void 0;
var React = require("react");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var reactstrap_1 = require("reactstrap");
var journey_services_1 = require("@athena-portal/journey-services");
var Types_1 = require("../../../Types");
var PropertyTypeWidget = exports.PropertyTypeWidget = /** @class */ (function (_super) {
    __extends(PropertyTypeWidget, _super);
    function PropertyTypeWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.flowWarningHeaderText = "Sorry, we can’t insure you";
        _this.furnishingDeclineType = "furnishing";
        _this.propertyDeclineType = "property";
        var propertyTypeSetting;
        propertyTypeSetting = _this.getSetting("interactionPropertyTypeSubType", undefined);
        if (propertyTypeSetting) {
            _this.interactionPropertyTypeSubtype = journey_services_1.ObjectManipulator.fetchFieldValue(propertyTypeSetting, _this.props.interaction);
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget is missing 'interactionPropertyTypeSubType' setting"));
        }
        var furnishingTypeSetting;
        furnishingTypeSetting = _this.getSetting("interactionFurnishingType", undefined);
        if (furnishingTypeSetting) {
            _this.interactionFurnishingType = journey_services_1.ObjectManipulator.fetchFieldValue(furnishingTypeSetting, _this.props.interaction);
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget is missing 'interactionFurnishingType' setting"));
        }
        _this.state = {
            showHousePropertyTypeOtherWarning: false,
            showHouseFurnishingTypeOtherWarning: false,
            propertyType: undefined,
            propertyKind: undefined,
            furnishingType: undefined,
            predefinedValuesAreSet: false
        };
        _this.toggleHidePropertyTypeOtherWarning = _this.toggleHidePropertyTypeOtherWarning.bind(_this);
        _this.toggleHideFurnishingTypeOtherWarning = _this.toggleHideFurnishingTypeOtherWarning.bind(_this);
        _this.renderSectionOfButtons = _this.renderSectionOfButtons.bind(_this);
        _this.renderListOfButtons = _this.renderListOfButtons.bind(_this);
        _this.onSelectTypeButton = _this.onSelectTypeButton.bind(_this);
        _this.onSelectKindButton = _this.onSelectKindButton.bind(_this);
        _this.onSelectFurnishingTypeButton = _this.onSelectFurnishingTypeButton.bind(_this);
        _this.fetchFurnishingTypePresetParameters = _this.fetchFurnishingTypePresetParameters.bind(_this);
        _this.fetchRealEstateTypeSubtypePresetParameters = _this.fetchRealEstateTypeSubtypePresetParameters.bind(_this);
        _this.getRealEstateTypes = _this.getRealEstateTypes.bind(_this);
        _this.getRealEstateTypeRelatedSubtypes = _this.getRealEstateTypeRelatedSubtypes.bind(_this);
        return _this;
    }
    PropertyTypeWidget.prototype.render = function () {
        if (this.state.predefinedValuesAreSet) {
            return (React.createElement("div", { className: "property-type-widget" },
                this.renderPropertyRelatedQuestions(),
                this.state.showHousePropertyTypeOtherWarning && this.renderPropertyTypeOtherWarning(this.propertyDeclineType),
                this.state.showHouseFurnishingTypeOtherWarning && this.renderPropertyTypeOtherWarning(this.furnishingDeclineType)));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    PropertyTypeWidget.prototype.componentDidMount = function () {
        this.fetchFurnishingTypePresetParameters();
        this.fetchRealEstateTypeSubtypePresetParameters();
    };
    PropertyTypeWidget.prototype.renderPropertyRelatedQuestions = function () {
        return (React.createElement(React.Fragment, null,
            this.renderSectionOfButtons("What type of property do you live in?", this.getRealEstateTypes(), true),
            (this.state.propertyType && this.getRealEstateTypeRelatedSubtypes(this.state.propertyType).length > 0) &&
                this.renderSectionOfButtons("What kind of " + this.state.propertyType.toLowerCase() + " is it?", this.getRealEstateTypeRelatedSubtypes(this.state.propertyType), false),
            this.state.furnishingTypeMap && (this.state.propertyKind || (this.state.propertyType && this.getRealEstateTypeRelatedSubtypes(this.state.propertyType).length < 1)) &&
                this.renderListOfButtons("Which of the below best describes your tenancy?", this.state.furnishingTypeMap, this.state.furnishingType)));
    };
    PropertyTypeWidget.prototype.renderSectionOfButtons = function (headerText, buttonOptions, isType) {
        var _this = this;
        var propertySource = isType ? "propertyType" : "propertyKind";
        var radioButtons = [];
        buttonOptions.forEach(function (value) {
            radioButtons.push(React.createElement("div", { className: "custom-control custom-radio specific-custom-radio " + (isType ? "" : "custom-radio-mobile-full-width") },
                React.createElement("input", { className: "custom-control-input vehicle-details-radio", type: "radio", name: propertySource + value, id: propertySource + value, value: value, checked: (isType ? _this.state.propertyType : _this.state.propertyKind) === value, onChange: isType ? _this.onSelectTypeButton : _this.onSelectKindButton }),
                React.createElement("label", { className: "custom-control-label", htmlFor: propertySource + value }, value)));
        });
        return (React.createElement("div", { className: "form-group mb-0" },
            React.createElement("label", { className: "mt-3" }, headerText),
            React.createElement("div", { className: "input-group width-auto", role: "group", "aria-label": propertySource }, radioButtons)));
    };
    PropertyTypeWidget.prototype.onSelectTypeButton = function (event) {
        var newValue = event.target.value;
        if (newValue === "Mobile home" || newValue === "Bedsit / Halls") {
            this.toggleHidePropertyTypeOtherWarning();
        }
        else {
            if (this.getRealEstateTypeRelatedSubtypes(newValue).length < 1) {
                this.props.onStateChange("".concat(this.props.question.settings.interactionPropertyTypeSubType), this.getTextValueByTypeAndSubtype(newValue, "None"));
            }
            else {
                this.props.onStateChange("".concat(this.props.question.settings.interactionPropertyTypeSubType), null);
            }
            this.setState({
                propertyType: newValue,
                propertyKind: undefined
            });
            this.changelogRecorder.recordPage("change", this.props, this.props.question.settings.interactionPropertyTypeSubType);
        }
    };
    PropertyTypeWidget.prototype.onSelectKindButton = function (event) {
        var newValue = event.target.value;
        if (this.state.propertyType) {
            this.props.onStateChange("".concat(this.props.question.settings.interactionPropertyTypeSubType), this.getTextValueByTypeAndSubtype(this.state.propertyType, newValue));
            this.changelogRecorder.recordPage("change", this.props, this.props.question.settings.interactionPropertyTypeSubType);
        }
        this.setState({
            propertyKind: newValue
        });
    };
    PropertyTypeWidget.prototype.renderListOfButtons = function (headerText, buttonOptions, furnishingType) {
        var _this = this;
        var radioButtons = [];
        buttonOptions.forEach(function (value, key) {
            radioButtons.push(React.createElement("div", { className: "custom-control margin-bottom-20-padding-left-0" },
                React.createElement("input", { className: "custom-radiobutton", type: "radio", name: "furnishingType" + key, id: "furnishingType" + key, value: value, checked: furnishingType === value, onChange: _this.onSelectFurnishingTypeButton }),
                React.createElement("label", { id: "driver-label", className: "checkbox-label label-bg-transparent", htmlFor: "furnishingType" + key }, value)));
        });
        return (React.createElement("div", { className: "form-group mb-0" },
            React.createElement("label", { className: "mt-3" }, headerText),
            React.createElement("div", { style: { display: 'block', marginBottom: '10px' }, className: "input-group margin-top-bottom-14", role: "group", "aria-label": "Furnishing type" }, radioButtons)));
    };
    PropertyTypeWidget.prototype.onSelectFurnishingTypeButton = function (event) {
        var newValue = event.target.value;
        if (newValue === "Other") {
            this.toggleHideFurnishingTypeOtherWarning();
        }
        else {
            this.props.onStateChange("".concat(this.props.question.settings.interactionFurnishingType), this.getKeyByValue(this.state.furnishingTypeMap, newValue));
            this.changelogRecorder.recordPage("change", this.props, this.props.question.settings.interactionFurnishingType);
            this.setState({
                furnishingType: newValue
            });
        }
    };
    PropertyTypeWidget.prototype.renderPropertyTypeOtherWarning = function (type) {
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: type === this.propertyDeclineType ? this.state.showHousePropertyTypeOtherWarning : this.state.showHouseFurnishingTypeOtherWarning, toggle: type === this.propertyDeclineType ? this.toggleHidePropertyTypeOtherWarning : this.toggleHideFurnishingTypeOtherWarning, backdrop: "static" },
                React.createElement(reactstrap_1.ModalHeader, { toggle: type === this.propertyDeclineType ? this.toggleHidePropertyTypeOtherWarning : this.toggleHideFurnishingTypeOtherWarning },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("img", { src: "/img/Flow-attention.svg", alt: "warning-sign" }),
                        React.createElement("span", { className: "ml-3 text-blue-2 fs-20 font-weight-medium" }, this.flowWarningHeaderText))),
                React.createElement(reactstrap_1.ModalBody, { className: "font-family-base font-weight-extra-light" },
                    type === this.propertyDeclineType && (React.createElement(React.Fragment, null,
                        "If you live in a ",
                        React.createElement("b", null, "bedsit"),
                        " (with cooking facilities in room), ",
                        React.createElement("b", null, "halls of residence"),
                        " or a ",
                        React.createElement("b", null, "mobile home"),
                        " we can\u2019t insure you.")),
                    type === this.furnishingDeclineType && (React.createElement(React.Fragment, null,
                        "Flow provides content insurance for tenants only.",
                        React.createElement("b", null, " If you are a homeowner, and you want to cover your personal possessions within the home, it\u2019s best to get a traditional home insurance quote instead.")))),
                React.createElement(reactstrap_1.ModalFooter, null,
                    React.createElement("div", { className: "w-100 d-flex flex-column justify-content-between" },
                        React.createElement("div", null,
                            React.createElement(reactstrap_1.Button, { className: "my-2 w-100", color: "btn btn-primary btn-next-no-arrow", href: "https://www.lv.com/home-insurance" }, "OK, I understand")),
                        React.createElement("div", null,
                            React.createElement(reactstrap_1.Button, { className: "my-2 w-100", color: "btn btn-white", onClick: type === this.propertyDeclineType ? this.toggleHidePropertyTypeOtherWarning : this.toggleHideFurnishingTypeOtherWarning }, "Cancel")))))));
    };
    PropertyTypeWidget.prototype.toggleHidePropertyTypeOtherWarning = function () {
        this.setState({ showHousePropertyTypeOtherWarning: !this.state.showHousePropertyTypeOtherWarning });
    };
    PropertyTypeWidget.prototype.toggleHideFurnishingTypeOtherWarning = function () {
        this.setState({ showHouseFurnishingTypeOtherWarning: !this.state.showHouseFurnishingTypeOtherWarning });
    };
    PropertyTypeWidget.prototype.fetchFurnishingTypePresetParameters = function () {
        var _this = this;
        this.falconConvenienceApiService.getFurnishingTypeParams()
            .subscribe(function (output) {
            var furnishingCodeToTextMap = new Map(Object.entries(output));
            var textValue = furnishingCodeToTextMap.get(_this.interactionFurnishingType);
            if (textValue) {
                _this.setState({
                    furnishingType: textValue
                });
            }
            _this.setState({
                furnishingTypeMap: furnishingCodeToTextMap
            });
        }, function () {
            throw Error("".concat(_this.props.question.type, " widget failed to fetch preset properties for realEstateTypeSubtype"));
        });
    };
    PropertyTypeWidget.prototype.fetchRealEstateTypeSubtypePresetParameters = function () {
        var _this = this;
        this.falconConvenienceApiService.getRealEstateTypeSubtypeParams(services_1.PRODUCT_RENTERS)
            .subscribe(function (output) {
            var realEstateTypeAndSubTypeArray = output;
            var realEstateTypeSubType = realEstateTypeAndSubTypeArray
                .find(function (e) { return e.typeSubTypeCode === _this.interactionPropertyTypeSubtype; });
            if (realEstateTypeSubType) {
                _this.setState({
                    propertyType: realEstateTypeSubType.type,
                    propertyKind: realEstateTypeSubType.subtype !== "None" ? realEstateTypeSubType.subtype : undefined
                });
            }
            _this.setState({
                predefinedValuesAreSet: true,
                realEstateTypeSubtypeArr: realEstateTypeAndSubTypeArray
            });
        }, function () {
            throw Error("".concat(_this.props.question.type, " widget failed to fetch preset properties for realEstateTypeSubtype"));
        });
    };
    PropertyTypeWidget.prototype.getRealEstateTypes = function () {
        var _a;
        var typeArr;
        typeArr = ((_a = this.state.realEstateTypeSubtypeArr) === null || _a === void 0 ? void 0 : _a.map(function (value) { return value.type; })) || [];
        return Array.from(new Set(typeArr));
    };
    PropertyTypeWidget.prototype.getRealEstateTypeRelatedSubtypes = function (realEstateType) {
        var subTypeArr = (this.state.realEstateTypeSubtypeArr || [])
            .filter(function (value) { return value.type === realEstateType; })
            .map(function (value) { return value.subtype; })
            .filter(function (subType) { return subType !== "None"; });
        return subTypeArr;
    };
    PropertyTypeWidget.prototype.getTextValueByTypeAndSubtype = function (type, subtype) {
        var realEstateTypeSubType = this.state.realEstateTypeSubtypeArr && this.state.realEstateTypeSubtypeArr
            .find(function (value) { return value.type === type && value.subtype === subtype; });
        if (realEstateTypeSubType) {
            return realEstateTypeSubType.typeSubTypeCode;
        }
        else {
            throw Error("".concat(this.props.question.type, " could not pick correct realEstateTypeSubType from provided type and value"));
        }
    };
    PropertyTypeWidget.prototype.getKeyByValue = function (map, value) {
        var firstFoundKey = Array.from(map.keys()).find(function (key) { return map.get(key) === value; });
        if (firstFoundKey) {
            return firstFoundKey;
        }
        else {
            throw Error("".concat(this.props.question.type, " no keys found for provided value") + value);
        }
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], PropertyTypeWidget.prototype, "changelogRecorder", void 0);
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.FalconConvenienceApiService),
        __metadata("design:type", Object)
    ], PropertyTypeWidget.prototype, "falconConvenienceApiService", void 0);
    return PropertyTypeWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=PropertyTypeWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/renters/PropertyTypeWidget.js
// module id = 2550
// module chunks = 0